import { Box, Card, Flex } from '@chakra-ui/react'
import type { InsuranceParamsVehiclePagedQuery } from 'BrokerTsLib/src/dtos'
import { useSearchParamsStatePersistance } from 'BrokerTsLib/src/hooks/useSearchParamsStatePersistance'
import { createContext, useEffect, useState } from 'react'

import { ShortInsurancesCarSearch } from '@/containers/search/ShortInsurancesCarSearch'
import { ShortInsurancesList } from '@/containers/shortInsurances/shortInsurancesList'
import type { IPaginationContext } from 'BrokerTsLib/src/interfaces/Pagination/Pagination'
import { DashboardHeader } from '../../containers/dashboard/DashboardHeader'
import { PageToolbar } from '../../containers/PageToolbar'
import { SearchButton } from '../../containers/search/SearchButton'
import { WithAuth } from '../../hoc/WithAuth'
import { useGetAllShortInsurances } from '../../hooks/useInsuranceParams'
import { PageWrapper } from '../../layouts/components/PageWrapper'


export const shortInsurancesCarsContext = createContext<IPaginationContext<InsuranceParamsVehiclePagedQuery>>({} as IPaginationContext<InsuranceParamsVehiclePagedQuery>)

const ShortInsurancesCarPageComponent = () => {
  const [filter, setFilter, searchParams] =
    useSearchParamsStatePersistance<InsuranceParamsVehiclePagedQuery>(
      {
        pageIndex: 1,
        pageSize: 10,
      },
    )

  const [isOpen, setOpen] = useState(searchParams.size > 0)
  const [deletedCounter, setDeletedCounter] = useState(0)

  const { data, mutateAsync: getAllAsync, isPending } = useGetAllShortInsurances()
  const items = data?.data

  const reloadData = () => setDeletedCounter(deletedCounter + 1)

  useEffect(() => {
    if (filter.pageSize) // nechci spoustet nacitani na pageload 2x
      getAllAsync(filter)
  }, [filter, deletedCounter])

  return (
    <PageWrapper
      header={<DashboardHeader title="Denní POV" />}
      mainProps={{ sx: { pt: { base: 0, md: 8 }, gap: 4, display: 'grid' } }}
    >
      <PageToolbar
        rightElements={
          <Flex sx={{ gap: 4 }}>
            <SearchButton isOpen={isOpen} toggleOpen={() => setOpen(!isOpen)} />
          </Flex>
        }
      />
      <shortInsurancesCarsContext.Provider
        value={{
          loading: isPending,
          totalCount: items?.totalCount ?? 0,
          currentPage: filter.pageIndex,
          pageSize: filter.pageSize ?? 10,
          filter: filter,
          setCurrentPage: (p: number) => setFilter({ ...filter, pageIndex: p }),
          setPageSize: (s: number) => setFilter({ ...filter, pageSize: s }),
          updateFilter: setFilter,
          reload: reloadData,
        }}
      >
        {isOpen && <ShortInsurancesCarSearch />}

        <Card>
          <Box sx={{ display: 'grid', gap: 8, placeItems: 'start', justifyItems: 'stretch' }}>
            <ShortInsurancesList items={items?.items ?? []} withPaginator />
          </Box>
        </Card>
      </shortInsurancesCarsContext.Provider>
    </PageWrapper>
  )
}

export const ShortInsurancesCarPage = WithAuth(ShortInsurancesCarPageComponent)